// Platform configuration for social links
import {
  Globe,
  Home
} from 'lucide-react';
import { 
  SiInstagram,
  SiWhatsapp,
  SiTiktok,
  SiYoutube,
  SiSpotify,
  SiThreads,
  SiFacebook,
  SiX,
  SiSoundcloud,
  SiSnapchat,
  SiPinterest,
  SiPatreon,
  SiTwitch,
  SiApplemusic,
  SiLinkedin,
  SiCalendly
} from 'react-icons/si';

export const PLATFORMS_CONFIG = [
  // Row 1
  { 
    id: 'instagram', 
    name: 'Instagram', 
    icon: <SiInstagram size={20} />, 
    color: 'bg-gradient-to-tr from-[#E4405F] via-[#F77737] to-[#FCAF45]', 
    placeholder: 'username', 
    prefix: 'https://instagram.com/', 
    canSync: true 
  },
  { 
    id: 'whatsapp', 
    name: 'WhatsApp', 
    icon: <SiWhatsapp size={20} />, 
    color: 'bg-[#25D366]', 
    placeholder: 'phone number', 
    prefix: 'https://wa.me/', 
    canSync: false 
  },
  { 
    id: 'tiktok', 
    name: 'TikTok', 
    icon: <SiTiktok size={20} />, 
    color: 'bg-black', 
    placeholder: 'username', 
    prefix: 'https://tiktok.com/@', 
    canSync: true 
  },
  { 
    id: 'youtube', 
    name: 'Youtube', 
    icon: <SiYoutube size={20} />, 
    color: 'bg-[#FF0000]', 
    placeholder: 'channel URL', 
    prefix: '', 
    canSync: true 
  },
  { 
    id: 'website', 
    name: 'Website', 
    icon: <Globe size={20} />, 
    color: 'bg-emerald-500', 
    placeholder: 'https://yoursite.com', 
    prefix: '', 
    canSync: false 
  },
  { 
    id: 'spotify', 
    name: 'Spotify', 
    icon: <SiSpotify size={20} />, 
    color: 'bg-[#1DB954]', 
    placeholder: 'artist/profile URL', 
    prefix: '', 
    canSync: false 
  },
  
  // Row 3
  { 
    id: 'threads', 
    name: 'Threads', 
    icon: <SiThreads size={20} />, 
    color: 'bg-black', 
    placeholder: 'username', 
    prefix: 'https://threads.net/@', 
    canSync: false 
  },
  { 
    id: 'facebook', 
    name: 'Facebook', 
    icon: <SiFacebook size={20} />, 
    color: 'bg-[#1877F2]', 
    placeholder: 'profile/page URL', 
    prefix: '', 
    canSync: false 
  },
  { 
    id: 'twitter', 
    name: 'X', 
    icon: <SiX size={20} />, 
    color: 'bg-black', 
    placeholder: 'username', 
    prefix: 'https://x.com/', 
    canSync: true 
  },
  
  // Row 4
  { 
    id: 'soundcloud', 
    name: 'SoundCloud', 
    icon: <SiSoundcloud size={20} />, 
    color: 'bg-[#FF5500]', 
    placeholder: 'profile URL', 
    prefix: '', 
    canSync: false 
  },
  { 
    id: 'snapchat', 
    name: 'Snapchat', 
    icon: <SiSnapchat size={20} />, 
    color: 'bg-[#FFFC00]', 
    placeholder: 'username', 
    prefix: 'https://www.snapchat.com/@', 
    canSync: false 
  },
  { 
    id: 'pinterest', 
    name: 'Pinterest', 
    icon: <SiPinterest size={20} />, 
    color: 'bg-[#BD081C]', 
    placeholder: 'profile URL', 
    prefix: '', 
    canSync: false 
  },
  
  // Row 5
  { 
    id: 'patreon', 
    name: 'Patreon', 
    icon: <SiPatreon size={20} />, 
    color: 'bg-[#FF424D]', 
    placeholder: 'creator name', 
    prefix: 'https://patreon.com/', 
    canSync: false 
  },
  { 
    id: 'twitch', 
    name: 'Twitch', 
    icon: <SiTwitch size={20} />, 
    color: 'bg-[#9146FF]', 
    placeholder: 'username', 
    prefix: 'https://twitch.tv/', 
    canSync: false 
  },
  { 
    id: 'applemusic', 
    name: 'Apple Music', 
    icon: <SiApplemusic size={20} />, 
    color: 'bg-[#FA243C]', 
    placeholder: 'artist/profile URL', 
    prefix: '', 
    canSync: false 
  },
  
  // Additional platforms
  { 
    id: 'linkedin', 
    name: 'LinkedIn', 
    icon: <SiLinkedin size={20} />, 
    color: 'bg-[#0A66C2]', 
    placeholder: 'profile URL', 
    prefix: '', 
    canSync: false 
  },
  { 
    id: 'calendly', 
    name: 'Calendly', 
    icon: <SiCalendly size={20} />, 
    color: 'bg-[#0069FF]', 
    placeholder: 'calendly.com/user', 
    prefix: 'https://calendly.com/', 
    canSync: false 
  },
  { 
    id: 'zillow', 
    name: 'Zillow', 
    icon: <Home size={20} />, 
    color: 'bg-[#1277E1]',
    placeholder: 'agent profile URL',
    prefix: '', 
    canSync: false 
  },
];

